import isFunction from 'lodash-es/isFunction';

import * as Types from './types';

export default ((reporter) => {
  const report = (inform: Types.Metric) => inform(reporter);
  const distribute = (metrics: Types.Metrics) =>
    Object.values(metrics).forEach(report);
  const validate = () => isFunction(reporter);
  const initialize = () => import('web-vitals').then(distribute);

  return validate() && initialize();
}) as Types.Default;
